export const siteSettings = {
  name: "Trade Flow HQ",
  link: "https://tradeflowhq.net",
  email: "support@tradeflowhq.net",
  appLink: "https://app.tradeflowhq.net",
};
